import { type ReactNode } from "react";
import { Drawer } from "vaul";

import { cnTwMerge } from "../../utils/cnTwMerge";

export type MobileDrawerProps = {
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
  contentClassName?: string;
  children?: ReactNode;
  fullHeight?: boolean;
  showHandle?: boolean;
  title?: string;
  description?: string;
};

export const MobileDrawer = ({
  isOpen,
  onOpenChange,
  className,
  contentClassName,
  children,
  fullHeight = false,
  showHandle = true,
  title,
  description,
}: MobileDrawerProps) => (
  <Drawer.Root onOpenChange={onOpenChange} open={isOpen}>
    <Drawer.Portal>
      <Drawer.Overlay className="fixed inset-0 overlay z-modal" />
      <Drawer.Content
        aria-describedby={undefined}
        className={cnTwMerge(
          "fixed bottom-0 left-0 right-0 flex flex-col items-start rounded-t-mobileDrawer bg-background/primary z-modal",
          "border border-border/default",
          fullHeight ? "h-full" : "max-h-[85dvh] min-h-[24rem]",
          className,
        )}
      >
        {title ? (
          <Drawer.Title className="sr-only">{title}</Drawer.Title>
        ) : null}
        {description ? (
          <Drawer.Description className="sr-only">
            {description}
          </Drawer.Description>
        ) : null}
        <div
          className={cnTwMerge(
            "flex flex-col w-full h-full min-h-0",
            contentClassName,
          )}
        >
          {showHandle ? (
            <div className="w-full flex justify-center p-4 pt-6 flex-shrink-0">
              <div className="h-2.5 w-12 rounded-default bg-background/secondary border border-border/default" />
            </div>
          ) : null}
          <div
            className={cnTwMerge(
              "flex-1 overflow-y-auto min-h-0",
              showHandle ? "px-4 pb-4" : "p-4",
            )}
          >
            {children}
          </div>
        </div>
      </Drawer.Content>
    </Drawer.Portal>
  </Drawer.Root>
);
